import { Heading, SubNav, useEntity } from 'components';
import type { ProviderAgreement } from 'modules/supplier/agreement/types';
import { activityTypeOptions } from 'options';
import type { ReactElement } from 'react';
import type { NavLinkProps } from 'react-router-dom';

export function Nav(): ReactElement {
  const { item } = useEntity<ProviderAgreement>();
  const nav: NavLinkProps[] = [
    {
      to: '',
      end: true,
      children: 'Update',
    },
    ...activityTypeOptions.map(({ value, label }) => ({
      to: `discounts/${value}`,
      children: item.types.includes(value) ? <strong>{label}</strong> : label,
      end: true,
    })),
  ];

  return (
    <SubNav nav={nav}>
      <Heading>
        <h2>
          Provider agreement <small className="text-muted">#{item.number}</small>
        </h2>
      </Heading>
    </SubNav>
  );
}
